import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IZCoreAIChatUser } from "./ZCoreAIChatUser";


export interface IZCoreAIChat extends IEntityWithStatus {
    AppID?: number;
    CreatedByUserID?: number;
    CreatedOn?: Date;
    UpdatedOn?: Date;
    LastPrompt?: string;
    LastPromptAt?: Date;
    TotalPrompts?: number;
    SummaryFrequency?: number;
    ChatContext?: string;

    ZCoreAIChatUsers?: IZCoreAIChatUser[];

}

export class ZCoreAIChat extends EntityWithStatus implements IZCoreAIChat {
    public AppID = null;
    public CreatedByUserID = null;
    public CreatedOn = null;
    public UpdatedOn = null;
    public LastPrompt = null;
    public LastPromptAt = null;
    public TotalPrompts = null;
    public SummaryFrequency = null;
    public ChatContext = null;
}